/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS202: Simplify dynamic range loops
 * DS203: Remove `|| {}` from converted for-own loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
    I interpret a test script to execute it against an ITDriver instance,
    instead of actually coding the driver interactions.  The language is
    designed to be highly human readable and minimize unneeded syntactic
    constructs (especially punctuation).  It took inspiration from the simple
    line-oriented format of Selenese (from Selenium IDE), the 'with' construct
    in ECMAScript, and semantic white-space of Python/CoffeeScript/etc.  That
    said, both 'with' and semantic whitespace are completely optional and only
    provide a means of reducing duplication between instructions, no additional
    functionality.

    The implementation uses a PEG grammar, which is compiled by PEG.js into a
    JavaScript parser implementation.  The resulting parse tree is then further
    analyzed, and if all is well, loaded into the application initialization
    framework and interpreted when it's ready.

    Events are triggered (using Backbone.Events) for all script errors,
    failures and command executions.  Error events are dispatched in an 'error'
    namespace with 'indent', 'syntax', or 'assert' or the offending command
    name as the local name.  All commands, actions, and inspections dispatch
    two with their name as the namespace and 'start' and 'done' as the local
    names.  While 'fail' conceptually does this, execution always terminates
    before it's 'done' event can trigger.

    With the exception of 'parse', 'parsed', 'validate', 'validated', 'start',
    'play', 'pause', 'close', and 'success', all events are passed the same
    three args: atom, payload, and a millisecond timestamp.  The specific
    payload varies between command types, with all error events receiving a
    string message. The first four exceptions listed above are passed a two
    arguments: an array of errors that have been identified and a timestamp. The
    'start' event is also passed two arguments: the promise returned by the
    invocation of the start method and a timestamp.  The 'play', 'pause',
    'close', and 'success' events are passed only a timestamp.

    By defaults, errors are NOT thrown by the methods, only events are
    dispatched.  The constructor's 'options' object supports a 'throwOnError'
    option which can be set to true to change this behaviour.  All errors are
    also aggregated in an 'errors' array on the object itself.
*/

import IT from "it/lib/pegjs/IT";
import wait from "it/lib/wait";
import utils from "it/lib/utils";
import assert from "it/lib/assert_moar";
import HybridConfig from "lib/HybridConfig";

const toIt = function(it) {
    let ts;
    if ((it == null)) {
        return it;
    }
    switch (ts = Object.prototype.toString.call(it)) {
        case "[object Array]":
            return (it.map((o) => o.it));
        case "[object Object]":
            return it.it;
        default:
            throw new Error(`toIt doesn't support ${ts}`);
    }
};

class Interpreter {

    constructor(appDriver, script, options) {
        this.parse = this.parse.bind(this);
        this._error = this._error.bind(this);
        this.now = this.now.bind(this);
        this._event = this._event.bind(this);
        this.validate = this.validate.bind(this);
        this.getScenario = this.getScenario.bind(this);
        this.getMockset = this.getMockset.bind(this);
        this.getUser = this.getUser.bind(this);
        this.getConfig = this.getConfig.bind(this);
        this.getPreferences = this.getPreferences.bind(this);
        this.start = this.start.bind(this);
        this.pause = this.pause.bind(this);
        this.close = this.close.bind(this);
        this.play = this.play.bind(this);
        this._closeWiths = this._closeWiths.bind(this);
        this._next = this._next.bind(this);
        this.step = this.step.bind(this);
        this.appDriver = appDriver;
        this.script = script;
        this.options = utils.extend({
            throwOnError: false,
            tickDelay: 0
        }
        , options);
        this._start = new Date().valueOf();
        this.playing = false;
        this.errors = [];
    }

    parse() {
        if (this.parsed) { return; }
        this.trigger("parse", this.errors, this.now());
        try {
            this.commands = IT.parse(this.script);
        } catch (e) {
            if (e instanceof IT.SyntaxError) {
                this._error(e, {
                    offset: e.offset,
                    line: e.line,
                    column: e.column,
                    len: e.found.length
                }
                );
                this.commands = [];
            } else {
                throw e;
            }
        }
        // check indentation
        for (const c of this.commands) {
            if ((c.indent.it.indexOf("\t")) >= 0) {
                this._error("indent", c.indent, "Test scripts cannot use tabs for indentation, only spaces");
            }
        }
        this.parsed = true;
        this.trigger("parsed", this.errors, this.now());
        return this;
    }

    _error(errorOrType, atom, message) {
        let error;
        let type = "error:unknown";
        if (errorOrType instanceof IT.SyntaxError) {
            type = "error:syntax";
            error = errorOrType;
        } else {
            if (errorOrType instanceof assert.AssertionError) {
                type = "error:assert";
                error = errorOrType;
            } else if (errorOrType instanceof Error) {
                error = errorOrType;
            } else {
                type = `error:${errorOrType}`;
                error = new Error(message != null ? message : "unknown error");
            }
            error.line = atom.line;
            error.column = atom.column;
        }
        this.errors.push(error);
        this._event(type, atom, error.message != null ? error.message : message);
        if (this.options.throwOnError) {
            throw error;
        } else {
            return console.error(error.message, error);
        }
    }

    now() {
        return new Date().valueOf() - this._start;
    }

    _event(type, atom, payload) {
        return this.trigger(type, atom, payload, this.now());
    }

    validate() {
        let d;
        if (this.validated) { return; }
        this.parse();
        this.trigger("validate", this.errors, this.now());
        // check the individual commands
        let blockDepths = [0];
        let directivesComplete = false;
        this.config = {};
        this.prefs = {};
        const counts = {
            mockset: 0,
            user: 0
        };
        for (let i = 0; i < this.commands.length; i++) {
            const curr = this.commands[i];
            counts[curr.cmd.it] += 1;
            const prev = i > 0
                ? this.commands[i - 1]
                : null;
            const next = i < this.commands.length
                ? this.commands[i + 1]
                : null;
            if (prev != null) {
                if (curr.depth > prev.depth) {
                    if ((prev.cmd.it !== "with")) {
                        this._error("indent", curr, "unexpected indent; only 'with' commands introduce new indentation for their nested commands.");
                    }
                }
                if (curr.depth < prev.depth) {
                    if (blockDepths.indexOf(curr.depth) < 0) {
                        this._error("indent", curr, "unexpected outdent.");
                    }
                }
            }
            if (curr.d) {
                if (directivesComplete) {
                    this._error("", curr, `Directives (like '${curr.cmd.it}' on ${curr.line}) must precede all commands`);
                }
            } else if (!directivesComplete) {
                directivesComplete = true;
            }
            switch (curr.cmd.it) {
                case "scenario":
                    if (curr.line !== 1) {
                        this._error("scenario", curr, "scenario is only allowed on the first line");
                    }
                    break;
                case "mockset": case "user":
                    if (counts[curr.cmd.it] > 1) {
                        this._error("", curr, `Only one '${curr.cmd.it}' directive is allowed per script'`);
                    }
                    if ((curr.val == null)) {
                        this._error("", curr, `${curr.cmd.it} requires one parameter`);
                    } else if (curr.val.it.indexOf(" ") >= 0) {
                        this._error("", curr, `${curr.cmd.it} does not accept multiple parameters`);
                    }
                    break;
                case "config":
                    if (this.config.hasOwnProperty(curr.key.text)) {
                        this._error("", curr, `Duplicate config '${curr.key.text}' found'`);
                    }
                    this.config[curr.key.text] = curr.val.it;
                    break;
                case "preference": {
                    if (this.prefs.hasOwnProperty(curr.key.text)) {
                        this._error("", curr, `Duplicate preference '${curr.key.text}' found'`);
                    }
                    const idx = curr.key.text.indexOf(".");
                    if ((idx < 0) || (idx !== curr.key.text.lastIndexOf("."))) {
                        this._error("", curr, "Preferences are set via a dot-separated 'impl-name.pref-name' pair.");
                    }
                    this.prefs[curr.key.text] = curr.val.it;
                    break;
                }
                case "with": {
                    if ((next == null) || (next.depth <= curr.depth)) {
                        this._error("with", curr, "'with' block has no nested commands");
                    }
                    const bi = next.depth;
                    // eslint-disable-next-line no-loop-func
                    blockDepths = ((() => {
                        const result = [];
                        for (d of blockDepths) { if (d < bi) {
                                result.push(d);
                            }
                        }
                        return result;
                    })());
                    blockDepths.push(bi);
                    break;
                }
                case "wait":
                    if ((curr.val != null) && !["sync", "ajax", "over", "viewstack"].includes(curr.val.it)) {
                        this._error("wait", curr.val, `'wait' command with an illegal type (${curr.val.it})`);
                    }
                    break;
                case "fail":
                    // no validation, just need to cover it so it's not treated as an action/inspection
                    break;
                default: {
                    if (curr.cmd.it === "exists") { // this one is special
                        if ((curr.chain == null)) {
                            this._error(curr.cmd.it, curr.cmd, "The 'exists' assertion must have a local selector chain");
                        }
                    }
                    const isAssert = curr.hasOwnProperty("assert");
                    const type = isAssert ? "inspections" : "actions";
                    const otherType = isAssert ? "actions" : "inspections";
                    if (!this.appDriver[type].hasOwnProperty(curr.cmd.it)) {
                        let msg = `unrecognized '${curr.cmd.it}' ${isAssert ? "inspection" : "action"}`;
                        if (this.appDriver[otherType].hasOwnProperty(curr.cmd.it)) {
                            msg += `, did you want the '${curr.cmd.it}' ${isAssert ? "action" : "inspection"}?`;
                        }
                        msg += ` (available ${type}: ${((() => {
                            const result1 = [];
                            for (const n of Object.keys(this.appDriver[type] || {})) {
                                result1.push(n);
                            }
                            return result1;
                        })()).join(", ")})`;
                        this._error(curr.cmd.it, curr.cmd, msg);
                        continue;
                    }
                    const argCount = (curr.args != null ? curr.args.length : undefined) != null ? (curr.args != null ? curr.args.length : undefined) : 0;
                    const func = this.appDriver[type][curr.cmd.it];
                    const maxArgCount = func.length - 1;
                    const optionalArgCount = ((func.meta != null ? func.meta.optionalArgCount : undefined) != null) ? func.meta.optionalArgCount : 0;
                    const minArgCount = maxArgCount - optionalArgCount;
                    if ((argCount < minArgCount) || (argCount > maxArgCount)) {
                        this._error(
                            curr.cmd.it,
                            (argCount > maxArgCount ? curr.args[maxArgCount] : curr),
                            `passed ${argCount} argument${argCount === 1 ? "" : "s"} to '${curr.cmd.it}' which requires ${minArgCount}${minArgCount === maxArgCount ? "" : `-${maxArgCount}`}`
                        );
                    }
                    if (isAssert) {
                        // inspection
                        if (!assert.hasOwnProperty(curr.assert.op.it)) {
                            this._error(curr.cmd.it, curr.assert.op, `unsupported '${curr.assert.op.it}' assertion`);
                        }
                    }
                }
            }
        }
        this.validated = true;
        this.trigger("validated", this.errors, this.now());
        return this;
    }

    getScenario() {
        this.parse();
        for (const c of this.commands) {
            if (c.cmd.it === "scenario") {
                return c.val.it;
            }
        }
        return null;
    }

    getMockset() {
        this.parse();
        for (const c of this.commands) {
            if (c.cmd.it === "mockset") {
                return c.val.it;
            }
        }
        return null;
    }

    getUser() {
        this.parse();
        for (const c of this.commands) {
            if (c.cmd.it === "user") {
                return c.val.it;
            }
        }
        return null;
    }

    getConfig() {
        this.parse();
        return this.config;
    }

    getPreferences() {
        this.parse();
        return this.prefs;
    }

    start(driver) {
        this.driver = driver;
        this._deferred = new $.Deferred();
        this.validate();
        const p = this._deferred.promise();
        if (this.errors.length) {
            this._deferred.reject(this.errors[0]);
        } else {
            this._index = null;
            this.trigger("start", p, this.now());
        }
        return p;
    }

    pause() {
        if (this.playing) {
            this.playing = false;
            return this.trigger("pause", this.now());
        }
    }

    close() {
        return this.trigger("close", this.now());
    }

    play() {
        if (!this.playing) {
            this.playing = true;
            this.trigger("play", this.now());
            return this._next();
        }
    }

    _closeWiths(newDepth) {
        const prev = this.commands[this._index - 1];
        if ((prev != null) && (newDepth < prev.depth)) {
            // need to pop some 'with' contexts
            let threshold = prev.depth - 1;
            return (() => {
                const result = [];
                for (let start = this._index - 2, i = start, asc = start <= 0; asc ? i <= 0 : i >= 0; asc ? i++ : i--) {
                    const c = this.commands[i];
                    if ((c.cmd.it === "with") && (c.depth < threshold) && (c.depth >= newDepth)) {
                        threshold = c.depth;
                        for (let j = 1, end = c.chain.length, asc1 = 1 <= end; asc1 ? j <= end : j >= end; asc1 ? j++ : j--) {
                            this.driver.pop();
                        }
                        result.push(this._event("with:done", c.cmd, c.chain));
                    } else {
                        result.push(undefined);
                    }
                }
                return result;
            })();
        }
    }

    _next() {
        return wait.tick({for: this.options.tickDelay}, () => {
            if (!this.playing) {
                return;
            }
            return this.step();
        });
    }

    step() {
        if (this._index != null) {
            this._index += 1;
        } else {
            this._index = 0;
        }

        this._deferred.notify(this._index / this.commands.length);

        if (this._index >= this.commands.length) {
            this._closeWiths(0);
            this._deferred.resolve();
            this.trigger("success", this.now());
            return;
        }

        const curr = this.commands[this._index];
        console.group(`IT> ${curr.text}`);
        const event = (typeSuffix, payload) => {
            let type;
            if (payload != null) {
                type = curr.cmd.it + ":" + typeSuffix;
            } else {
                payload = typeSuffix;
                type = curr.cmd.it;
            }
            return this._event(type, curr.cmd, payload);
        };
        const doChain = chain => {
            let proceed = true;
            for (const link of chain) {
                try {
                    this.driver.with.call(this.driver, link.it);
                } catch (se) {
                    this._error(se, link);
                    this._deferred.reject(se);
                    proceed = false;
                    break;
                }
            }
            if (proceed && HybridConfig.get("it.autoscroll", true)) {
                this.driver.element[0].scrollIntoView(false);
            }
            return proceed;
        };
        if (this._index > 0) {
            this._closeWiths(curr.depth);
        }
        try {
            switch (curr.cmd.it) {
                case "scenario": case "mockset": case "user":
                    event("start", curr.val.it);
                    event("done", curr.val.it);
                    return this._next();
                case "config": case "preference":
                    event("start", curr.key.it, curr.val.it);
                    event("done", curr.key.it, curr.val.it);
                    return this._next();
                case "wait": {
                    let delay = 10000;
                    let val = "sync";
                    if ((curr.val != null) && (curr.delay != null)) {
                        val = curr.val.it;
                        delay = curr.delay.it;
                    } else if (curr.val != null) {
                        val = curr.val.it;
                    } else if (curr.delay != null) {
                        val = "tick";
                        delay = curr.delay.it;
                    }
                    event("start", val);
                    return wait[val]({for: delay}, () => {
                        event("done", val);
                        return this._next();
                    }
                    , o => {
                        this._error(o.__error, curr);
                        return this._deferred.reject(o.__error);
                    });
                }
                case "with":
                    wait.sync({for: 10000}, function() {}, o => {
                        this._error(o.__error, curr);
                        return this._deferred.reject(o.__error);
                    });
                    event("start", toIt(curr.chain));
                    if (doChain(curr.chain)) {
                        return this._next();
                    }
                    break;
                case "fail": {
                    const msg = __guard__(curr.args != null ? curr.args[0] : undefined, x => x.it) != null ? __guard__(curr.args != null ? curr.args[0] : undefined, x => x.it) : "Fail";
                    event("start", msg);
                    assert.ok(false, msg);
                    return event("done", msg);
                }
                case "exit": {
                    const msg = __guard__(curr.args != null ? curr.args[0] : undefined, x1 => x1.it) != null ? __guard__(curr.args != null ? curr.args[0] : undefined, x1 => x1.it) : "Early Exit";
                    utils.info("Exit", msg);
                    this._index = this.commands.length;
                    return this._next();
                }
                case "pause":
                    event("start", "pause");
                    event("done", "pause");
                    // eslint-disable-next-line no-settimeout
                    return setTimeout(() => this.pause()
                    , 0);
                case "close":
                    // eslint-disable-next-line no-settimeout
                    return setTimeout(() => {
                        this.playing = false;
                        return this.close();
                    }
                    , 0);
                default:
                    // invocation is the same for both actions and inspections
                    const isAssert = curr.hasOwnProperty("assert");
                    const payload = {
                        chain: toIt(curr.chain),
                        args: toIt(curr.args),
                    };
                    if (isAssert) {
                        payload.op = curr.assert.op.it;
                        payload.val = curr.assert.val.it;
                    }
                    event("start", payload);
                    let value = undefined;
                    const isExists = curr.cmd.it === "exists";
                    if (isExists) { // this one is special
                        const last = curr.chain[curr.chain.length - 1];
                        value = true;
                        const chainHead = curr.chain.slice(0, curr.chain.length - 1);
                        if (!doChain(chainHead)) {
                            break;
                        }
                        try {
                            this.driver.with.call(this.driver, last.it);
                            this.driver.pop();
                        } catch (error) {
                            value = false;
                        }
                        // eslint-disable-next-line no-unused-vars
                        for (const c of chainHead) {
                            this.driver.pop();
                        }
                    } else {
                        if (curr.chain != null) {
                            if (!doChain(curr.chain)) {
                                break;
                            }
                        }
                        const fn = this.driver[curr.cmd.it];
                        value = fn.apply(this.driver, (curr.args != null) ? payload.args : []);
                    }
                    if (isAssert) {
                        // inspection
                        let val = curr.assert.val.it;
                        if (typeof val === "string") {
                            val = $.trim(val);
                            value = $.trim(value);
                        }
                        try {
                            assert[curr.assert.op.it](value, val);
                        } catch (ae) {
                            this._error(ae, curr.assert.op);
                            this._deferred.reject(ae);
                            break;
                        }
                    }
                    if (!isExists && (curr.chain != null)) {
                        // eslint-disable-next-line no-unused-vars
                        for (const c of curr.chain) {
                            this.driver.pop();
                        }
                    }
                    event("done", payload);
                    return this._next();
            }
        } catch (e) {
            this._error(e, curr.cmd);
            return this._deferred.reject(e);
        }
        finally {
            console.groupEnd();
        }
    }
}

_.extend(Interpreter.prototype, Backbone.Events);
export default Interpreter;

function __guard__(value, transform) {
  return (typeof value !== "undefined" && value !== null) ? transform(value) : undefined;
}



// WEBPACK FOOTER //
// ./test/it/lib/Interpreter.js